(function () {
  if (window.customElements.get('timeline-component')) return;

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function isMobile() {
    return mobileQuery.matches;
  }

  class TimelineComponent extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.timeline');
      this.rows = this.querySelectorAll('[data-timeline-row]');
      this.updateStickyTop();
      if (this.rows.length < 2) return;

      this.rowsHolder = this.querySelector('[data-timeline-rows]');
      this.buttons = this.querySelectorAll('[data-timeline-button]');
      this.rowsHeight = [];
      this.rowsWidth = 0;
      this.requestAnimation = null;
      this.lastWidth = window.innerWidth;

      this.onWindowScroll = function () {
        this.updateStickyTop();
        if (!isMobile()) this.schedule(null);
      }.bind(this);
      this.onHolderScroll = function () {
        this.schedule(this.rowsHolder);
      }.bind(this);
      this.onResize = function () {
        if (window.innerWidth === this.lastWidth) return;
        this.lastWidth = window.innerWidth;
        this.resizeEvents();
      }.bind(this);
      this.onLoad = this.resizeEvents.bind(this);
      this.onBlockSelect = function (event) {
        var index = Array.prototype.indexOf.call(this.rows, event.target);
        if (index > -1) this.scrollToRow(index);
      }.bind(this);

      this.measure();
      this.schedule(null);

      window.addEventListener('scroll', this.onWindowScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      window.addEventListener('load', this.onLoad);
      this.rowsHolder.addEventListener('scroll', this.onHolderScroll, { passive: true });
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.onButtonClick = function (event) {
        event.preventDefault();
        var row = event.currentTarget.closest('[data-timeline-row]');
        var index = Array.prototype.indexOf.call(this.rows, row);
        if (index > -1) this.scrollToRow(index);
      }.bind(this);
      this.buttons.forEach(function (button) {
        button.addEventListener('click', this.onButtonClick);
      }, this);
    }

    updateStickyTop() {
      if (!this.section) return;
      var header = document.querySelector('.site-header.site-header--stuck');
      var top = header ? header.offsetHeight : 0;
      if (top !== this.stickyTop) {
        this.stickyTop = top;
        this.section.style.setProperty('--tl-sticky-top', top + 'px');
      }
    }

    measure() {
      this.holderTop = this.getBoundingClientRect().top + window.scrollY;
      this.holderHeight = this.offsetHeight;
      this.rowsHeight = [];
      this.rowsWidth = 0;
      this.rows.forEach(function (row) {
        this.rowsHeight.push(row.offsetHeight);
        this.rowsWidth += row.offsetWidth + (parseInt(window.getComputedStyle(row).marginRight, 10) || 0);
      }, this);
    }

    resizeEvents() {
      this.updateStickyTop();
      this.measure();
      this.schedule(null);
    }

    schedule(target) {
      if (this.requestAnimation) return;
      this.requestAnimation = window.requestAnimationFrame(function () {
        this.calculatePosition(target);
      }.bind(this));
    }

    calculatePosition(target) {
      this.requestAnimation = null;
      this.holderTop = this.getBoundingClientRect().top + window.scrollY;

      var desktop = !isMobile();
      var step = this.holderHeight / this.rows.length;
      var rowTop = this.holderTop;
      var viewport = window.innerHeight;
      var threshold = window.scrollY + 1.5 * viewport;
      var percent = 0;

      if (!desktop && target) {
        var scrollLeft = target.scrollLeft - 16;
        var width = target.offsetWidth;
        percent = (scrollLeft / (this.rowsWidth - width)) * 100;
        this.style.setProperty('--percent-mobile', percent + '%');
      }

      if (desktop && (threshold < this.holderTop || threshold > this.holderTop + this.holderHeight + viewport)) return;

      this.rows.forEach(function (row, index) {
        if (index > 0) {
          var selected = percent > (row.offsetLeft / this.rowsWidth) * 100;
          if (desktop) {
            selected = rowTop + step < threshold;
            if (rowTop - step < threshold && row.previousElementSibling) {
              row.previousElementSibling.style.setProperty('--percent-desktop', ((threshold - rowTop) / step) * 100 + '%');
            }
          }
          row.classList.toggle('is-selected', selected);
        }
        rowTop += step;
      }, this);
    }

    scrollToRow(index) {
      var row = this.rows[index];
      if (!row) return;

      if (isMobile()) {
        this.rowsHolder.scrollTo({ left: row.offsetLeft - 16, behavior: 'smooth' });
        return;
      }

      var tallest = Math.max.apply(null, this.rowsHeight);
      var step = this.holderHeight / this.rows.length;
      var top = this.getBoundingClientRect().top;
      var offset = (index > 0 && tallest < step ? step * index + top : top) + 1;
      window.scrollTo({ top: window.scrollY + offset, behavior: 'smooth' });
    }

    disconnectedCallback() {
      if (this.requestAnimation) window.cancelAnimationFrame(this.requestAnimation);
      this.requestAnimation = null;
      if (!this.rowsHolder) return;
      window.removeEventListener('scroll', this.onWindowScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onLoad);
      this.rowsHolder.removeEventListener('scroll', this.onHolderScroll);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.buttons.forEach(function (button) {
        button.removeEventListener('click', this.onButtonClick);
      }, this);
    }
  }

  window.customElements.define('timeline-component', TimelineComponent);
})();
